// React & React Hooks
import { useContext } from 'react';
import { useNavigate } from "react-router-dom";

import _ from 'lodash';

// Third-party libraries
import { useTranslation } from 'react-i18next';
import { Box, Card, Grid, Stack, Typography } from '@mui/material';

// Shared / reusable components
import DataCardGrid from '../../shared-components/DataCardGrid/DataCardGrid';

// Services / utilities
import { httpPost } from '../../services/commonService';

// Project constants
import urlConstant from '../../constants/urlConstants';
import dataConstants from '../../constants/dataConstants';

// Context / Providers
import { AuthenticationContext } from '@cloudmlm/cloudmlm-auth';

const Order = () => {
  const { t } = useTranslation();
  const { accessToken, impersonateEmail } = useContext(AuthenticationContext);
  const navigate = useNavigate();

  const handleViewDetails = (row) => {
    navigate(`/vieworder/${row.Id}`);
  };

  const columns = [
    {
      key: 'OrderID',
      label: t('Order.Order ID'),
      type: 'text',
      isFilterVisible: true,
    },
    {
      key: 'OrderTotal',
      label: t('Order.Order Total'),
      type: 'text',
      isFilterVisible: true,
    },
    {
      key: 'ItemName',
      label: t('Order.Ordered Item'),
      type: 'text',
      isFilterVisible: true,
    },
    {
      key: 'OrderDate',
      label: t('Order.Order Date'),
      type: 'date',
      isFilterVisible: true,
    },
    {
      key: 'OrderStatus',
      label: t('Order.Order Status'),
      type: 'text',
      isFilterVisible: true,
      statusIcon: true,
    },
  ];

  const commissionGridButtons = [
    {
      id: 'view-details',
      label: 'View',
      icon: 'eye',
      color: 'secondary-main',
      onClick: handleViewDetails,
    },
  ];

  const fetchDataFunction = async ({
    page,
    pageSize,
    search,
    filters,
    sortKey,
    sortDirection,
  }) => {
    const getUserOrderList = urlConstant.Order.OrderList;
    const pagingInfo = {
      PageNumber: page,
      RowsPerPage: pageSize,
      CommonSearchText: search,
      SortColumns: {
        SortColumnName: sortKey,
        SortOrder: sortDirection,
      },
      Filter: {
        OrderStatus: filters?.OrderStatus,
        OrderDate: filters?.OrderDate,
        OrderItem: filters?.ItemName,
        OrderId: filters?.OrderID,
        OrderTotal: filters?.OrderTotal,
      },
    };
    const requestBody = {
      PagingInfoVM: pagingInfo,
    };
    try {
      const response = await httpPost(
        getUserOrderList,
        requestBody,
        true,
        false,
        accessToken,
        impersonateEmail
      );
      if (response?.Value?.Status === dataConstants.APIResponseStatus.Success) {
        const orderData = _.map(response.Value.Data.Data, (item) => ({
          ...item, 
          isEdit: true 
        }))
        return {
          data: orderData,
          totalCount: response.Value.Data.TotalCount,
        };
      } else {
        return { data: [], totalCount: 0 };
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Box flexDirection={'column'} gap={2} display={'flex'}>
        <Typography color='secondary.light' variant='h4' fontWeight={600}>
          {t("My Account")}
        </Typography>
        <Box width={'100%'}>
          <Card
            sx={(theme) => ({
              p: {
                xs: '20px',
                sm: '25px 30px',
              },
              background: theme.palette.background.cardGradient,
              border: '1px solid var(--headerbg)',
              borderRadius: '20px',
              height: '100%',
            })}
          >
            <Stack gap={'20px'}>
              <Typography color='secondary.light' variant='h4' fontWeight={600}>
                {t('Order.Order History')}
              </Typography>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                  <DataCardGrid
                    onFetchData={fetchDataFunction}
                    columns={columns}
                    defaultItemsPerPage={8}
                    defaultColumnsPerGrid={3}
                    enableExport={true}
                    enablePagination={true}
                    uniqueId='commission-grid'
                    actionButtons={commissionGridButtons}
                  />
                </Grid>
              </Grid>
            </Stack>
          </Card>
        </Box>
      </Box>
    </>
  );
};

export default Order;